import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { forwardRef } from 'react';

import ErrorBoundary from 'components/ErrorBoundary';

import { makeUnifiedNodesConfig } from 'lib/textEditor';

import ErrorBoundaryFallback from './ErrorBoundaryFallback';
import { $addEmojiNodeConfig } from './Nodes/EmojiNode';
import { $addImageNodeConfig } from './Nodes/ImageNode';
import { $addLinkNodeConfig } from './Nodes/LinkNode';
import { $addMentionNodeConfig } from './Nodes/MentionNode';
import { $addParagraphNodeConfig } from './Nodes/ParagraphNode';
import { $addSkeletonNodeConfig } from './Nodes/SkeletonNode';
import { $addTextNodeConfig } from './Nodes/TextNode';
import { $addVideoNodeConfig } from './Nodes/VideoNode';
import Editor from './TextEditor';

const EDITOR_CONFIG = {
  nodes: makeUnifiedNodesConfig([
    $addEmojiNodeConfig,
    $addImageNodeConfig,
    $addLinkNodeConfig,
    $addMentionNodeConfig,
    $addParagraphNodeConfig,
    $addSkeletonNodeConfig,
    $addTextNodeConfig,
    $addVideoNodeConfig,
  ]),
  onError(error) {
    throw error;
  },
};

const TextEditor = forwardRef(({ children, ...props }, ref) => (
  <ErrorBoundary fallback={ErrorBoundaryFallback}>
    <LexicalComposer initialConfig={EDITOR_CONFIG}>
      <Editor ref={ref} {...props} />
      {children}
    </LexicalComposer>
  </ErrorBoundary>
));

TextEditor.displayName = 'TextEditor';

export default TextEditor;
